// extracted by mini-css-extract-plugin
export default {"text":"ListEmptyText_text__FQQzj"};